import { Checkbox } from "@/components/ui/checkbox";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/ui/password-input";

import type { EmailConnectionFormValues } from "./email-connection-schema";
import type { EmailConnection } from "@artisancode/api-types";
import type { UseFormReturn } from "react-hook-form";

export function EmailConnectionFields({
  form,
  editing,
}: {
  form: UseFormReturn<EmailConnectionFormValues>;
  editing: EmailConnection | null;
}) {
  return (
    <div className="grid gap-3">
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nama Koneksi</FormLabel>
            <FormControl>
              <Input placeholder="misal: SMTP Gmail" autoFocus {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="fromAddress"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Alamat Pengirim (From)</FormLabel>
            <FormControl>
              <Input
                type="email"
                placeholder="noreply@jamcoffee.id"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="smtpHost"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Host</FormLabel>
            <FormControl>
              <Input placeholder="smtp.gmail.com" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="smtpPort"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Port</FormLabel>
            <FormControl>
              <Input type="number" placeholder="587" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="smtpUsername"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Username</FormLabel>
            <FormControl>
              <Input placeholder="user@gmail.com" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="smtpPassword"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Password</FormLabel>
            <FormControl>
              <PasswordInput
                placeholder={
                  editing?.hasSmtpPassword
                    ? "•••••••••••• (biarkan kosong untuk tetap pakai yang lama)"
                    : "App Password / SMTP password"
                }
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="smtpSecure"
        render={({ field }) => (
          <FormItem className="flex items-center gap-2 space-y-0">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={(v) => field.onChange(v === true)}
              />
            </FormControl>
            <Label className="text-sm font-normal">
              Gunakan TLS/SSL (umumnya aktif untuk port 465)
            </Label>
          </FormItem>
        )}
      />
    </div>
  );
}
